import PropTypes from 'prop-types';
import { Component } from 'react';
import Constants, { getTypeByColor } from './Constants';
import Alert, { BUTTON } from '../Alert/Alert';

class StatusBar extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isVisible: this.props.isVisible,
		};

		this.onButtonClick = this.onButtonClick.bind(this);
	}

	onButtonClick() {
		if (this.props.targetUrl) {
			window.location.href = this.props.targetUrl;
		} else {
			this.setState({
				isVisible: false,
			});
		}
	}

	render() {
		if (!this.state.isVisible) {
			return null;
		}

		const buttons = [];
		if (this.props.btnLabel) {
			buttons.push({ text: this.props.btnLabel, onClick: this.onButtonClick, type: BUTTON.SECONDARY });
		}

		return <Alert type={getTypeByColor(this.props.barColor)} headline={this.props.msgIntro} text={this.props.msgOutro} buttons={buttons} />;
	}
}

StatusBar.propTypes = {
	barColor: PropTypes.string,
	msgIntro: PropTypes.string,
	msgOutro: PropTypes.string,
	btnLabel: PropTypes.string,
	isVisible: PropTypes.bool,
	targetUrl: PropTypes.string,
};

StatusBar.defaultProps = {
	barColor: Constants.BARCOLOR_WHITE,
	isVisible: true,
};

export default StatusBar;
